import React, { useState } from 'react';
import logo from '@/assets/logo.png';
import { FaPhoneAlt, FaWhatsapp, FaFacebookF, FaInstagram } from 'react-icons/fa';
import MenuMobile from '@/components/MenuMobile'; // ajuste o caminho se necessário
import { useLocation } from 'react-router-dom';
import Letreiro from '@/components/Letreiro'; // ajuste o caminho se necessário
import ModalContato from '@/components/ModalContato'; // ✅ ajuste o caminho conforme seu projeto
import { Link } from "react-router-dom"; // certifique-se de importar
import { useNavigate } from "react-router-dom";







export default function Navbar() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [mostrarModalContato, setMostrarModalContato] = useState(false);
  const navigate = useNavigate();

  const links = [
    { label: 'Home', href: '/home' },
    { label: 'Sobre Nós', href: '/sobre' },
    { label: 'Serviços', href: '/servicos' },
    { label: 'Fotos', href: '/fotos' },
    { label: 'Contatos', href: '/contatos' },
  ];

  const location = useLocation();

  const handleLogout = () => {
  // Exemplo: remove o cookie ou localStorage, dependendo do que você usa
  localStorage.removeItem('token'); // ou cookies, se aplicável
  navigate('/login');
};

  return (
    <>
      <header className="relative z-50 text-white bg-cover bg-center" style={{ backgroundImage: "url('/bg-navbar.jpeg')" }}>
        {/* Top bar com ícones e links */}
        <div className="flex justify-between items-center px-4 py-2 bg-black bg-opacity-70 text-sm">
          <div className="flex items-center gap-4 text-white">
            <a href="tel:+5531993127020" className="flex items-center gap-1 hover:text-[#b8936a]">
              <FaPhoneAlt className="text-xs" />
              (31) 99312-7020
            </a>
            <a
              href="https://wa.me/5531993127020"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 hover:text-[#b8936a]"
            >
              <FaWhatsapp className="text-lg" />
              (31) 99312-7020
            </a>
          </div>
          <div className="flex items-center gap-4 text-white">
             {/*<a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#b8936a]">
              <FaFacebookF className="text-lg" />
            </a>*/}
            <a href="https://www.instagram.com/higienizacao_prime/?igsh=MW9kbXB5OWF1MnVteQ%3D%3D" target="_blank" rel="noopener noreferrer" className="hover:text-[#b8936a]">
              <FaInstagram className="text-lg" />
            </a>
          </div>
        </div>

<nav className="px-4 py-3 bg-white/10 backdrop-blur-md border-b border-white/20">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between">
    
    {/* Logo centralizada com link para /login */}
    <div className="flex items-center justify-center space-x-3 mb-4 md:mb-0">
      <Link to="/login">
        <img
          src={logo}
          alt="Logo Master Clean"
          className="h-12 md:h-16 lg:h-20 w-auto cursor-pointer hover:opacity-80 transition-all duration-300"
        />
      </Link>
    </div>


            {/* Menu desktop */}
            <ul className="hidden md:flex items-center gap-6 text-[18px] font-medium text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {links.map(({ label, href }) => (
                <li key={label}>
                  <a
                    href={href}
                    className={`px-4 py-1 rounded-full border border-transparent hover:border-[#b8936a] hover:bg-white/10 transition duration-300 ${
                      window.location.pathname === href ? 'border-black text-white-800 bg-white/20' : ''
                    }`}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>

{/* Botão hamburguer (mobile only) */}
<div className="absolute right-4 top-4 md:hidden">
  <button
    className="text-white text-3xl"
    onClick={() => setMenuAberto(!menuAberto)}
    aria-label="Abrir menu"
    aria-expanded={menuAberto}
  >
    ☰
  </button>
</div>
          </div>
        </nav>

        {/* Hero Section */}
        {(location.pathname === '/' || location.pathname === '/home') && (
  <div className="text-center py-24 px-4 md:py-32 relative z-0">
    <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white drop-shadow-lg mb-6 animate-slide-down tracking-tight">
      Limpeza de Estofados
    </h1>
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium text-white drop-shadow-md mb-8 animate-slide-up">
      Serviços Especializados com Qualidade
    </h2>
<button
  onClick={() => setMostrarModalContato(true)}
  className="inline-block bg-[#C9AA7B] hover:bg-[#b8936a] text-white font-bold py-3 px-8 rounded-full transition duration-300 shadow-lg animate-pulse-scale"
>
  Orçamento Grátis
</button>


  </div>
)}
      </header>
      <Letreiro />

      {/* Menu Mobile renderizado corretamente */}
      <MenuMobile aberto={menuAberto} fechar={() => setMenuAberto(false)} links={links} />
{['/agendamentos', '/cliente', '/painel'].includes(location.pathname) && (
  <div className="hidden md:flex justify-end px-4 py-2">
    <button
      onClick={handleLogout}
      className="bg-[#C9AA7B] hover:bg-[#b8936a] text-white font-bold py-2 px-6 rounded-full shadow-lg transition-all duration-300"
    >
      Sair
    </button>
  </div>
)}


        <ModalContato
  aberto={mostrarModalContato}
  onFechar={() => setMostrarModalContato(false)}
/>
    </>
  );
}
